import { useAppSelector } from 'app/hooks';
import { ConfigurationType } from 'data/types';
import useHybridLeftoverSpaceIds from 'hooks/use-hybrid-leftover-space-ids';
import { shallowEqual } from 'react-redux';
import { selectEligibleConfigurations } from 'utils/pathway-configurations';

export default function useEligibleConfigurations(): ConfigurationType[] {
  const leftoverSpaceIds = useHybridLeftoverSpaceIds();
  return useAppSelector(
    (state) => selectEligibleConfigurations(state, leftoverSpaceIds),
    shallowEqual
  );
}
